<template>
  <div class="login">
    <Card shadow>
      <div slot="title">
        <img src="../assets/images/eKuiper-logo.png" width="50" alt="kuiper-logo" />
        <p>eKuiper Dashboard</p>
      </div>
      <Form ref="record" :model="record" :rules="rules" @keyup.enter.native="handleSubmit">
        <FormItem prop="username">
          <i-input v-model="record.username" type="text" size="large" :placeholder="$t('common.username')">
            <Icon slot="prepend" type="ios-person"></Icon>
          </i-input>
        </FormItem>
        <FormItem prop="password">
          <i-input v-model="record.password" size="large" type="password" :placeholder="$t('common.password')">
            <Icon slot="prepend" type="ios-lock"></Icon>
          </i-input>
        </FormItem>
        <FormItem>
          <Button class="login-btn" type="primary" size="large" :loading="loginLoading" @click="handleSubmit">{{
            $t('common.login')
          }}</Button>
        </FormItem>
      </Form>
    </Card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import auth from '@/api/auth'

export default {
  name: 'Login',

  data() {
    return {
      loginLoading: false,
      record: {
        username: '',
        password: '',
        remember: true,
      },
      rules: {
        username: [{ required: true, message: this.$t('common.usernameRequried'), trigger: 'blur' }],
        password: [{ required: true, message: this.$t('common.passwordRequired') }],
      },
    }
  },

  created() {
    this.UPDATE_USER_INFO({ logout: true })
  },

  methods: {
    ...mapActions(['UPDATE_USER_INFO']),
    handleSubmit() {
      this.$refs.record.validate((valid) => {
        if (!valid) {
          return
        }
        this.loginLoading = true
        const { username, password, remember } = this.record
        auth({ username, password })
          .then((res) => {
            const { data } = res
            this.UPDATE_USER_INFO({
              userId: data.id,
              username: data.username,
              token: data.token,
              refreshToken: data.refreshToken,
              roleId: data.roleId,
              remember,
            })
            this.loginLoading = false
            this.$router.push({ path: '/' })
          })
          .catch(() => {
            this.loginLoading = false
          })
      })
    },
  },
}
</script>

<style lang="scss">
.login {
  width: 100%;
  height: 100%;
  background-image: url('../assets/images/login-bg.svg');
  background-size: cover;
  background-position: bottom;

  .ivu-card {
    background: #fff;
    width: 400px;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    .ivu-card-head {
      text-align: center;
      border-bottom: none;
      font-weight: 600;
      padding-top: 80px;
      padding: 80px 16px 0px;
    }
    .ivu-card-head p,
    .ivu-card-head-inner {
      color: #00b173;
      font-size: 18px;
      margin-top: 20px;
    }
    .ivu-card-head p i,
    .ivu-card-head p span {
      font-size: 20px;
      position: relative;
      top: -1px;
      margin-right: 10px;
    }
    .ivu-card-body {
      padding: 40px 60px 80px;
    }
  }
  .ivu-input {
    border: 1px solid #dcdee2;
    color: #515a6e;
  }
  .ivu-form-item:last-child {
    margin-bottom: 0px;
  }
  .ivu-form-item-required .ivu-form-item-label:before {
    display: none;
  }
  .ivu-icon {
    font-size: 18px;
    &.ivu-icon-ios-loading {
      font-size: 14px;
    }
  }
  .login-btn {
    width: 100%;
    margin-top: 16px;
    box-shadow: 3px 3px 6px 0px #00b1738c;
    font-weight: 500;
  }
}
</style>
